import { render, staticRenderFns } from "./cmy.vue?vue&type=template&id=2b503355&scoped=true"
import script from "./cmy.vue?vue&type=script&lang=js"
export * from "./cmy.vue?vue&type=script&lang=js"
import style0 from "./cmy.vue?vue&type=style&index=0&id=2b503355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b503355",
  null
  
)

export default component.exports